// 차량관리 2차 바 — 검차 셸 크롬(SimpleChrome) 앱바 아래. 항목 = routes.js MANAGE_ITEMS(차량·인보이스·수출서류·세무·장부·바이어·설정).
// 라벨은 menus.js 한국어 그대로라 dir=ltr 고정(아래 ERP 화면과 같은 방향 — 옛 런처와 동일). 스타일은 simple.css .ss-subbar/.ss-sub.
// props: { items: [{ id, label }], activeId, onSelect(id) }
import React from 'react';

function ManageBar(props) {
  return (<nav className="ss-subbar" dir="ltr">
    {(props.items || []).map(function (it) {
      var on = it.id === props.activeId;
      return (<button key={it.id} type="button" data-sub={it.id} className={'ss-sub' + (on ? ' on' : '')}
        aria-current={on ? 'page' : undefined} onClick={function () { props.onSelect(it.id); }}>{it.label}</button>);
    })}
  </nav>);
}

export default ManageBar;
